module.exports = __webpack_public_path__ + "static/media/bumperBoat.84a424d1.jpg";